import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";
import { useCellEdit } from "./use-cell-edit";

export default function CellCheckbox<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table, t } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as boolean;

  const [value, setValue] = useState(cellValue);
  const header = cell.column.columnDef.header;
  const accessibleName =
    typeof header === "string" ? header : t("toggleCellValue");

  useEffect(() => {
    setValue(cellValue);
  }, [cellValue]);

  const { controlProps } = useCellEdit<T, HTMLInputElement>({
    row,
    cell,
    isChanged: () => value !== cellValue,
    commit: () => {
      try {
        updateData?.(row, columnId, value);
      } catch (error) {
        console.error(error);
        setValue(cellValue);
      }
    },
    restore: () => setValue(cellValue),
    describeValue: () => (value ? t("booleanYes") : t("booleanNo")),
  });

  return (
    <label className="flex h-target items-center">
      <input
        {...controlProps}
        type="checkbox"
        checked={value}
        onChange={() => {
          setValue(!value);
        }}
        disabled={isUpdating}
        className="form-checkbox h-4 w-4 text-primary focus:ring-focus border-default rounded disabled:opacity-50"
      />
      <span className="sr-only">{accessibleName}</span>
    </label>
  );
}
